export default {
  // 充值记录
  walletRechargeRecord: { url: '/v1/sys/wallet/rechargePage' }, // 1
  // 消费记录
  walletConsumePage: { url: '/v1/sys/wallet/consumePage' }, // 1
  // 查询价格配置
  walletQueryPriceConfigPage: { url: '/v1/sys/wallet/queryPriceConfigPage' }, // 1
  // 发票记录
  walletInvoicePage: { url: '/v1/sys/wallet/invoicePage' }, // 1
  // 申请开票
  walletApplyInvoice: { url: '/v1/sys/wallet/applyInvoice' }, // 1
  // 当前余额
  tenantMoney: { url: '/v1/sys/payment/getTenantMoney' }, // 1
  // 充值下单
  rechargeOrder: { url: '/v1/sys/payment/orderInfo' }, // 1
  // 二维码
  generateQrCode: { url: '/v1/sys/payment/generateQrCode' }, // 1
  // 结果轮询
  rechargeBack: { url: '/v1/sys/payment/rechargeBack' }, // 1
  // 修改用户
  userUpdate: { url: '/v1/sys/user/update' }, // 1
  // 用户详情
  userDetail: { url: '/v1/sys/user/detail' }, // 1
  // 租户查询
  tenantQuery: { url: '/v1/tenant/getTenant' }, // 1
  // 更新租户
  tenantUpdate: { url: '/v1/tenant/update' }, // 1
  // 文件上传接口
  fileUpload: { url: '/file/upload' }, // 1
  // 用户分页
  userPage: { url: '/v1/sys/user/page' }, // 1
  // 查看所有角色
  roleQueryList: { url: '/v1/sys/role/queryList' },
  // 更换管理员
  updateAdmin: { url: '/v1/sys/user/updateAdmin' }, // 1
  // 创建角色
  roleCreate: { url: '/v1/sys/role/create' }, // 1
  // 重命名角色
  roleUpdateName: { url: '/v1/sys/role/updateName' }, // 1
  // 删除角色
  roleDelete: { url: '/v1/sys/role/deleteById' }, // 1
  // 资源树-租户
  roleTree: { url: '/v1/sys/role/tree' }, // 1
  // 设置访问可用资源-就是授权
  roleSetResource: { url: '/v1/sys/role/set/resource' }, // 1
  // 登录日志-分页
  rLoginRecordQueryPage: { url: '/v1/sys/rLoginRecord/queryPage' }, // 1
  // 查看授权记录表
  authorizationQuery: { url: '/v1/query/authorization/query' }, // 1
  // 获取未读消息数
  notifyUnreadCount: { url: '/v1/notify/unreadCount' }, // 1
  // 获取消息列表
  notifyList: { url: '/v1/notify/history' }, // 1
  // 更新消息状态
  notifyUpdate: { url: '/v1/notify/update' }, // 1
  // 获取对公转账未支付的数据
  paymentOrderInfo: { url: '/v1/sys/payment/queryOrderInfo' }, // 1
  // 对公转账取消订单
  paymentDelOrderInfo: { url: '/v1/sys/payment/deleteOrderInfo' }, // 1
  // 获取对公转账的信息
  paymentQueryTransfer: { url: '/v1/sys/payment/queryTransfer' }, // 1
  // 添加对公转账信息
  paymentSaveTransfer: { url: '/v1/sys/payment/saveTransfer' }, // 1
};
